export const getLoanDetailsOpenStateAction = (state = false, action) => {
  switch (action.type) {
    case "OPEN_LOAN_DETAILS_STATE":
      return action.data;

    default:
      return state;
  }
};
